<template>
  <div
    class="button-link"
    :class="{ disable: disable, able: !disable }"
    @click="onClick"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "button-link",
  props: {
    text: { type: String },
    disable: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (!this.disable) {
        this.$emit("click-text", this.text);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.button-link {
  margin: 8px 0;
  text-align: center;
  border-radius: 4px;
  background-color: #5cd5d6;
  border: 1px solid #5cd5d6;
  padding: 1rem 0;
  font-weight: 700;
}
.able {
  color: white;
}
.disable {
  color: #c3c3c3;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/ButtonLink.vue